
import QReleaseSetting from "@/components/common/qReleaseSetting.vue";
import { STATUS, STATUS_SEND_MAIL } from "@/model/releaseSetting";
import { Component } from "vue-property-decorator";

@Component({
  name: "QReleaseSettingSendMail",
})
export default class QReleaseSettingSendMail extends QReleaseSetting {
  public statusList = STATUS_SEND_MAIL;
  public releaseStatus = STATUS.SEND;
  public releaseNowText = "今すぐ送信";
}
